module.exports = __webpack_public_path__ + "static/img/course-1.3a445f74.jpg";